"use strict";

var _objectSpread = require("/Volumes/Github-Projects/book-package-viewer-poc/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/objectSpread2");

var cov_2b87b8daos = function () {
  var path = "/Volumes/Github-Projects/gitea-react-toolkit/src/components/application-bar/useStyles.js";
  var hash = "8689bd5a7b072989c63c07e9a7521c2e5bab4dfe";
  var global = new Function("return this")();
  var gcv = "__coverage__";
  var coverageData = {
    path: "/Volumes/Github-Projects/gitea-react-toolkit/src/components/application-bar/useStyles.js",
    statementMap: {
      "0": {
        start: {
          line: 3,
          column: 20
        },
        end: {
          line: 3,
          column: 23
        }
      },
      "1": {
        start: {
          line: 5,
          column: 25
        },
        end: {
          line: 49,
          column: 3
        }
      },
      "2": {
        start: {
          line: 5,
          column: 46
        },
        end: {
          line: 49,
          column: 1
        }
      }
    },
    fnMap: {
      "0": {
        name: "(anonymous_0)",
        decl: {
          start: {
            line: 5,
            column: 36
          },
          end: {
            line: 5,
            column: 37
          }
        },
        loc: {
          start: {
            line: 5,
            column: 46
          },
          end: {
            line: 49,
            column: 1
          }
        },
        line: 5
      }
    },
    branchMap: {},
    s: {
      "0": 0,
      "1": 0,
      "2": 0
    },
    f: {
      "0": 0
    },
    b: {},
    _coverageSchema: "43e27e138ebf9cfc5966b082cf9a028302ed4184",
    hash: "8689bd5a7b072989c63c07e9a7521c2e5bab4dfe"
  };
  var coverage = global[gcv] || (global[gcv] = {});

  if (coverage[path] && coverage[path].hash === hash) {
    return coverage[path];
  }

  return coverage[path] = coverageData;
}();

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useStyles = void 0;

var _styles = require("@material-ui/core/styles");

var drawerWidth = (cov_2b87b8daos.s[0]++, 360);
var useStyles = (cov_2b87b8daos.s[1]++, (0, _styles.makeStyles)(function (theme) {
  cov_2b87b8daos.f[0]++;
  cov_2b87b8daos.s[2]++;
  return {
    root: {
      flexGrow: 1
    },
    grow: {
      flexGrow: 1
    },
    hide: {
      display: 'none'
    },
    appBar: {},
    menuButton: {
      marginLeft: -12,
      marginRight: 20
    },
    drawer: {
      width: drawerWidth,
      flexShrink: 0,
      zIndex: '10000'
    },
    drawerPaper: {
      width: drawerWidth
    },
    drawerHeader: _objectSpread({
      display: 'flex',
      alignItems: 'center',
      padding: '0 8px'
    }, theme.mixins.toolbar, {
      justifyContent: 'flex-end'
    }),
    // RepositoryMenu and UserMenu
    avatar: {
      width: '35px',
      height: '35px'
    },
    modal: {
      position: 'absolute',
      top: '10%',
      left: '10%',
      right: '10%',
      maxHeight: '80%',
      overflow: 'scroll'
    }
  };
}));
exports.useStyles = useStyles;